import React, {useEffect, useMemo, useRef} from 'react';
import {
  Box,
  useMediaQuery,
  CircularProgress,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip
} from '@mui/material';
import {useState, useCallback} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import {useBoolean} from 'src/hooks/use-boolean';
import {useAppContext} from '@context/AppContext';
import NavPreviewVertical from './NavPreviewVertical';
import {useTheme} from '@mui/material/styles';
import {useSettingsContext} from 'src/minimal-components/settings';
import Main from 'src/layouts/main';
import {HEADER, NAV} from 'src/layouts/config-layout';
import {useOffSetTop} from 'src/hooks/use-off-set-top';
import {useResponsive} from 'src/hooks/use-responsive';
import {bgBlur} from 'src/theme/css';
import {useLocation, useNavigate} from 'react-router-dom';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  LMS_PREVIEW_ID,
  LMS_IS_ADMIN,
  BASE_UNIQUE_TYPE
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import FormConstants from '@shared/constants/FormConstants';
import {
  DownloadUploadData,
  getLMSResultsData,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import axios, {CancelTokenSource} from 'axios';
import PreviewDoc from './ContentPreview';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import ContentViewer from './ContentViewer';
import Logo from '@components/logo';
import AccountPopover from 'src/layouts/common/account-popover';
import {environment} from '@shared/config/environment';
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: number;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_sub_type_id: number;
    module_link_id: number;
    module_id: number;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: number;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_sub_type_id: number;
      module_link_id: number;
      module_id: number;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}

const TestDetailsPage = (uiFields: any) => {
  const location = useLocation();
  const {uiFieldsvals} = location.state || {};
  // console.log('location.state', location.state);
  const nav = useBoolean();
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    appState: {applicationName}
  } = useAppContext();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const source = React.useRef<CancelTokenSource | null>(null);

  const query = useQuery();
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const section = query.get('section');
  const subSection = query.get('subsection');
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const filetype = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_TYPE
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const previewId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_PREVIEW_ID
  );
  const settings = useSettingsContext();
  const [loading, setLoading] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(true);
  const isNavHorizontal = settings.themeLayout === 'horizontal';
  const isNavMini = settings.themeLayout === 'mini';
  const [uiFieldsPreview, setUiFields] = useState();
  const lgUp = useResponsive('up', 'lg');
  const offset = useOffSetTop(HEADER.H_DESKTOP);
  const offsetTop = offset && !isNavHorizontal;
  const isMini = settings.themeLayout === 'mini';
  // const {isPlaying, setIsPlaying} = useModulePreviewContext();

  const {ModulePreviewData, SetModulePreviewData, fetchData, setFetchData} =
    useModulePreviewContext();
  const [mainContent, setMainContent] = useState<ModuleData[]>([]);
  const {selectedPreviewFile, setSelectedPreviewFile} =
    useModulePreviewContext();
  const onRoleChange = async () => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: uniqueId,
      [LMS_TYPE]: lmstype,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=module`,
      {
        state: {}
      }
    );
  };
  // const [viewdFile, setViewedFile] = useState<any>(null);
  const init = async () => {
    try {
      let resp: any = {};
      if (!uiFieldsPreview) {
        resp = await getSearchForm(applicationName, 'module', 'mainPage');
        await setUiFields(resp.searchForm);
      }
      // console.log('uiFieldsPreview', uiFieldsPreview);
      if (uiFieldsPreview || resp.searchForm) {
        const {sql_data} =
          (resp.searchForm['module_sql'] || uiFieldsPreview?.['module_sql']) ??
          '';
        const datavalue = {
          course_overview_id: uniqueId,
          isAdmin: lmsisAdmin === 'True'
        };
        const data: any = {
          sql_data: sql_data,
          data: datavalue,
          operation: 'SEARCH'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        const processModulesData = (data: ModuleData[]) => {
          return data.map(module => ({
            ...module,
            files:
              module.files?.map(file => ({
                ...file,
                locked_linked_items:
                  typeof file.locked_linked_items === 'string'
                    ? JSON.parse(file.locked_linked_items) // 🛠️ Parse if string
                    : file.locked_linked_items || [],
                additionalFiles:
                  typeof file.additionalFiles === 'string'
                    ? JSON.parse(file.additionalFiles) // 🛠️ Parse if string
                    : file.additionalFiles || [] // Keep array or default to empty
              })) || []
          }));
        };

        // Handling API result
        if (result.data) {
          const processedModules = processModulesData(result.data);
          await SetModulePreviewData(processedModules);
          // await setMainContent(processedModules);

          // Find the specific file inside the correct module
          let selectedFile: any = null;

          // Loop through modules to find the correct module and file
          const updatedModules = processedModules.map(module => {
            if (module.id === moduleId) {
              return {
                ...module,
                expanded: true,
                files: module.files?.map(file => {
                  if (file.id === fileId && file.type===filetype) {
                    selectedFile = {...file, fileexpanded: true}; // Store the file after updating
                    return selectedFile;
                  }
                  return {...file, fileexpanded: false}; // Collapse all other files
                })
              };
            }
            return module;
          });
          // console.log('updatedModules', updatedModules, selectedFile);
          // Set the updated module preview data
          await SetModulePreviewData(updatedModules);
          // setMainContent(updatedModules);
          // Ensure selectedFile is set before updating preview state
          if (selectedFile) {
            setSelectedPreviewFile(selectedFile);
            // setViewedFile(selectedFile);
          }
        }

        // await handleLegacyAppChange();
        setIsLoaded(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoaded(false);
    }
  };
  useEffect(() => {
    // console.log(
    //   'selectedPreviewFile',
    //   selectedPreviewFile,
    //   // viewdFile,
    //   ModulePreviewData
    //   // mainContent
    // );
    const fetchDatas = async () => {
      try {
        //console.log('uniqueId', uniqueId, moduleId, fileId, uiFieldsvals);
        if (!uiFieldsvals) {
          //console.log('enerss');

          await init();
        } else {
          setUiFields(uiFieldsvals);
          await init();
        }
      } catch (error) {
        console.error('error', error);
      }
    };
    if (
      (ModulePreviewData.length === 0 && !selectedPreviewFile) ||
      (fetchData !== undefined && fetchData?.fetched)
    ) {
      // console.log(
      //   'selectedPreviewFile',
      //   selectedPreviewFile,
      //   ModulePreviewData
      // );
      fetchDatas();
      setFetchData(undefined);
    } else {
      // setMainContent(ModulePreviewData);
      // setViewedFile(selectedPreviewFile);
      setIsLoaded(false);
    }
  }, []);
  // ✅ Update ref but do not trigger a re-render
  const handleChangeFile = (e: any) => {
    // console.log(e);
    // setViewedFile(e);
  };
  const handleChangeModule = (e: any) => {
    console.log('moduledata', e);
    // setMainContent(e);
  };

  // useEffect(() => {
  //   console.log(
  //     'compoParent Re-rendered, selectedPreviewFiles:',
  //     selectedPreviewFile
  //   );
  // }, [selectedPreviewFile]);

  const renderNavVertical = (
    <NavPreviewVertical
      navData={selectedPreviewFile}
      uiFieldsPreview={uiFieldsPreview}
      isOpenNav={nav.value}
      onCloseNav={nav.onFalse}
      isLoading={loading}
      applicationName={applicationName}
      onFileChange={countItem => {
        handleChangeFile(countItem);
      }}
    />
  );
  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: 1
      }}>
      {/* <Logo
        disabledLink={true}
        applicationName={'LMS'}
        sx={{mt: 3, ml: 4, mb: 1}}
      /> */}
      <Box>
        {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED && (
          <AccountPopover isDashboard={true} />
        )}
        <Tooltip title="Close">
          <IconButton onClick={() => onRoleChange()}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
  return (
    <>
      <AppBar
        sx={{
          height: HEADER.H_MOBILE,
          zIndex: theme.zIndex.appBar + 1,
          ...bgBlur({
            color: theme.palette.background.default
          }),
          transition: theme.transitions.create(['height'], {
            duration: theme.transitions.duration.shorter
          }),
          ...(lgUp && {
            width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
            height: HEADER.H_DESKTOP,
            ...(offsetTop && {
              height: HEADER.H_DESKTOP_OFFSET
            }),
            ...(isMini && {
              width: 1,
              bgcolor: 'background.default',
              height: HEADER.H_DESKTOP_OFFSET,
              borderBottom: `dashed 1px ${theme.palette.divider}`
            })
          }),
          borderBottom: theme => `dashed 1px ${theme.palette.divider}`
        }}>
        <Toolbar
          sx={{
            height: 1
            // px: {lg: 5}
          }}>
          {renderContent}
        </Toolbar>
      </AppBar>
      {isLoaded ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            height: '100vh',
            flexDirection: {xs: 'column', lg: 'row'},
            bgcolor: '#f4f5f7',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}>
          {!isMini && renderNavVertical}

          <Container
            maxWidth={settings.themeStretch ? false : 'lg'}
            sx={{
              top: HEADER.H_MOBILE,
              position: 'relative',
              zIndex: theme.zIndex.appBar + 1,
              ...bgBlur({
                color: theme.palette.background.default
              }),
              transition: theme.transitions.create(['height'], {
                duration: theme.transitions.duration.shorter
              }),
              ...(lgUp && {
                width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
                top: HEADER.H_DESKTOP,
                position: 'relative',
                ...(offsetTop && {
                  top: HEADER.H_DESKTOP_OFFSET
                }),
                ...(isNavHorizontal && {
                  width: 1,
                  bgcolor: 'background.default',
                  position: 'relative',
                  top: HEADER.H_DESKTOP_OFFSET,
                  borderBottom: `dashed 1px ${theme.palette.divider}`
                }),
                ...(isNavMini && {
                  width: `calc(100% - ${NAV.W_MINI + 1}px)`
                })
              })
            }}>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                display: 'flex',
                flexDirection: 'column'
              }}>
              <ContentViewer
                navData={selectedPreviewFile}
                isOpenNav={nav.value}
                onCloseNav={nav.onFalse}
                isLoading={loading}
                onFileChange={(countItem: any) => {
                  handleChangeFile(countItem);
                }}
              />
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};

export default TestDetailsPage;

